import getCookie from './getCookie';


const postServerResponse = async (endpoint, label, user_response) => {
    try {
        const token = getCookie("auth-cookie");
        const baseURL = process.env.REACT_APP_BASEURL + endpoint;
        const response = await fetch(baseURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ label, user_response, token }),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data.detail);
        }

        return response.json();
    } catch (error) {
        throw error;
    }
};

export default function infoUpdate(endpoint, label, response) {

    return postServerResponse(endpoint, label, response);
}
